/**
 * ID生成ユーティリティ
 * 一意なIDを生成するための共通関数
 */

/**
 * タイムスタンプとランダム文字列を組み合わせた一意なIDを生成
 * @param prefix IDの接頭辞（例: "toast", "session"）
 * @returns 一意なID文字列
 */
export function generateUniqueId(prefix: string = 'id'): string {
  const timestamp = Date.now();
  const randomStr = Math.random().toString(36).substr(2, 9);
  return `${prefix}_${timestamp}_${randomStr}`;
}
